module.exports = __webpack_public_path__ + "img/hero-sns_billymorgan.6da1a38.jpg";